export default "__VITE_ASSET__D1FDdoOQ__"